import { useVerificationFlow } from "./useVerificationFlow";
import useVerificationQuestions from "./useVerificationQuestions";
import { useMemo } from "react";

export default function useUseCaseVerificationStatus() {
  const { data: { results } = {} } = useVerificationFlow({
    flowType: "acceptable_use_violation",
  });

  const useCaseVerification = results?.[0];
  const { id, needs_evidence } = useCaseVerification || {};

  // for mutating verificationbanner keys

  const { data: { results: questionResults } = {} } = useVerificationQuestions({
    flowType: "acceptable_use_violation",
  });

  const hasUnansweredQuestions = useMemo(() => {
    return !!questionResults?.filter((item) => item.answer === null)?.length;
  }, [questionResults]);

  return useMemo(() => {
    const getStatus = () => {
      if (typeof id === "undefined") return null;

      if (hasUnansweredQuestions) return "additional-questions";

      if (needs_evidence) return "needs-evidence";

      return "in-review";
    };
    const status = getStatus();
    return {
      status,
    };
  }, [id, hasUnansweredQuestions, needs_evidence]);
}
